import React from 'react';
import PropTypes from 'prop-types';
import { HIDE_PRODUCT_CONNECTED_HOME } from 'src/constants/app';
import { BUTTON_CTAS } from 'src/containers/CartPage/constants';
import Button, { THEMES } from 'HTKit/Forms/Button';
import Avatar from 'src/components/HTKit/Elements/Avatar';
import { TechRatingBadge } from 'src/containers/DirectBooking/TechSkusPage/Parts';

const FloatingHeaderContent = ({ techInfo, techName, onProductClick, onServiceClick }) => {
  if (!techInfo) return null;
  const { profilePicture, rating } = techInfo;
  const showProductsButton = !HIDE_PRODUCT_CONNECTED_HOME;

  return (
    <div className="flex alignItemsCenter justifyContentSpaceBetween">
      <div className="flex text-align-center alignItemsCenter">
        <Avatar
          image={profilePicture && profilePicture.medium}
          name={techName}
          imageAlt={techName}
        />
        <h5 className="marginLeft-small">{techName}</h5>
        {!!rating && <TechRatingBadge rating={rating} className="marginLeft-tiny1" />}
      </div>
      <div className="flex">
        {showProductsButton && (
          <Button theme={THEMES.V2SECONDARY} className="marginRight-small" onClick={onProductClick}>
            {BUTTON_CTAS.PRODUCTS}
          </Button>
        )}
        <Button theme={THEMES.V2PRIMARY} onClick={onServiceClick}>
          Book a Service
        </Button>
      </div>
    </div>
  );
};

FloatingHeaderContent.propTypes = {
  techInfo: PropTypes.object,
  techName: PropTypes.string,
  onProductClick: PropTypes.func,
  onServiceClick: PropTypes.func,
};

export default FloatingHeaderContent;
